import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },

  disabled: {
    '& *': {
      color: 'grey',
      cursor: 'default !important'
    }
  },

  actions: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    paddingTop: '1rem'
  },

  icon: {
    cursor: 'pointer',
    fontSize: theme.size.base,
    color: theme.palette.primary.main
  },

  menuItem: {
    display: 'flex',
    margin: '0.5rem 0.25rem',
    cursor: 'pointer',
    fontSize: theme.size.sm
  },

  menuIcon: {
    marginRight: '0.705rem',
    fontSize: theme.size.base,
    color: theme.palette.primary.main
  },

  spacer: {
    alignItems: 'center',
    justifyContent: 'center',
    margin: '10px 0',
    width: '100%',
    maxWidth: '150px'
  },

  buttons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',

    '& > :not(:last-child)': {
      padding: ({ smallMedia }) => (smallMedia ? '0' : '0.5rem 1.5rem')
    },

    '& > *': {
      marginRight: '8px',
      height: '100%'
    },

    '& > :last-child': {
      marginRight: '0'
    }
  },

  send: {
    fontSize: theme.size.sm,
    borderRadius: '100rem',
    width: 'auto',
    '& .icon': {
      marginLeft: '0.3125rem',
      fontSize: theme.size.base
    },

    [theme.breakpoints.down('sm')]: {
      '& .icon:first-child:last-child': {
        marginLeft: 'auto !important',
        marginRight: 'auto !important'
      }
    }
  },

  submitButton: {
    '& *': {
      color: 'white',
      cursor: 'pointer !important'
    }
  },

  sendMsg: {
    justifyContent: 'flex-end',
    minWidth: '2.25rem',
    minHeight: '1.75rem',
    padding: '0',
    fontSize: theme.size.sm,
    color: theme.palette.button.text,

    '& > span': {
      justifyContent: 'center'
    },

    '& .icon': {
      marginLeft: '0 !important'
    },
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center'
    }
  }
}))

export default useStyles
